import { Dictionary } from "./types";

export const SapPermissions = {
    lookupsFullAccess: "LOOKUPS_FULL_MANAGE",
    projectsFullAccess: "PROJECTS_FULL_ACCESS",
    adminControl: "ADMIN_CONTROL",
    usersFullAccess: "USERS_FULL_ACCESS",
    attendanceDevicesFullAccess: "ATTENDANCE_DEVICES_FULL_ACCESS",
    manageTenants: "MANAGE_TENANTS",

    tenantConfigView: "TENANT_CONFIG_VIEW",
    tenantConfigEdit: "TENANT_CONFIG_EDIT",
    tenantConfigEditRestricted: "TENANT_CONFIG_EDIT_RESTRICTED",
    systemHiddenFeatureAccess: "HIDDEN_FEATURE_ACCESS",
    tenantPackagesEdit: "TENANT_PACKAGES_EDIT",
    referralProgramManage: "REFERRAL_PROGRAM_MANAGE",
    referralProgramMember: "REFERRAL_PROGRAM_MEMBER",

    //Finance
    transactionEntry: "TRANSACTION_ENTRY",
    transactionReconcile: "TRANSACTION_RECONCILE",
    transactionView: "TRANSACTION_VIEW",

    //Farming
    cropTrackingFullAccess: "CROP_TRACKING_FULL_ACCESS",
    harvestLogFullAccess: "HARVEST_LOG_FULL_ACCESS",

    //HR
    workLogsView: "WORK_LOGS_VIEW",
    workLogsSelfView: "WORK_LOGS_SELF_VIEW",
    workLogsFullAccess: "WORK_LOGS_FULL_ACCESS",
    payrollFullAccess: "PAYROLL_FULL_ACCESS",
    attendanceLogsView: "ATTENDANCE_LOGS_VIEW",
    attendanceLogsFullAccess: "ATTENDANCE_LOGS_FULL_ACCESS",
    attendanceDevicesView: "ATTENDANCE_DEVICES_VIEW",
    employeesFullAccess: "EMPLOYEES_FULL_ACCESS",
    employeesView: "EMPLOYEES_VIEW",
    employeesSalaryView: "EMPLOYEES_SALARY_VIEW",
    employeesSalaryEdit: "EMPLOYEES_SALARY_EDIT",
    employeesSalaryAdmin: "EMPLOYEES_SALARY_ADMIN",
    employeesOnlineChecking: "EMPLOYEES_ONLINE_CHECKING",
    leaveTypesFullAccess: "LEAVE_TYPES_FULL_ACCESS",
    leaveManage: "LEAVE_MANAGE",
    leaveApprove: "LEAVE_APPROVE",
    leaveFinalApprove: "LEAVE_FINAL_APPROVE",
    leaveRequest: "LEAVE_REQUEST",
    leaveRequestOnBehalfOf: "LEAVE_REQUEST_ONBEHALF",
    attendanceQRView: "ATTENDANCE_QR_VIEW",
    attendanceQRManage: "ATTENDANCE_QR_MANAGE",
    attendanceQRScan: "ATTENDANCE_QR_SCAN",

    //Stock Market
    stockMarketEventAnalytics: "STOCK_MARKET_EVENT_ANALYTICS",

    //Invoicing
    invoicesView: "INVOICES_VIEW",
    invoicesAction: "INVOICES_ACTION",

    //Voucher
    vouchersView: "VOUCHERS_VIEW",
    vouchersCreate: "VOUCHERS_CREATE",
    voucherApprove: "VOUCHERS_APPROVE",

    //Products
    productsView: "PRODUCTS_VIEW",
    productsFullAccess: "PRODUCTS_FULL_ACCESS",

    //Customers
    customersView: "CUSTOMERS_VIEW",
    customersFullAccess: "CUSTOMERS_FULL_ACCESS",

    //Project Time Logs
    ProjectTimeLogsFullAccess: "PROJECT_TIME_LOGS_FULL_ACCESS",
    ProjectTimeLogsView: "PROJECT_TIME_LOGS_VIEW",
    ProjectTimeLogsSelfAccess: "PROJECT_TIME_LOGS_SELF_ACCESS",
};

export const ErrorCodes: Dictionary = {
    ERR_CANT_DELETE_RECONCILED_TXN: "Reconciled transactions cannot be deleted.",
    ERR_INSUFFICIENT_PERMISSION_TO_DELETE_TRNASACTION: "You don't have permission to delete this transaction.",
};

export const Features = {
    Accounting: {
        Transactions: "TRANSACTIONS",
        BillingProofUpload: "BILLING_PROOF_UPLOAD",
        Vouchers: "VOUCHERS",
        Invoices: "INVOICES",
        PaymentVouchersCreateTransactions: "VOUCHERS_CREATE_TRANSACTIONS",
    },
    Farming: {
        HarvestLog: "HARVEST_LOG",
        CropTracking: "CROP_TRACKING",
        AdvancedCropTracking: "ADVANCED_CROP_TRACKING",
    },
    HR: {
        EmployeeManagement: "EMPLOYEE_MANAGEMENT",
        AttendanceDevices: "ATTENDANCE_DEVICES",
        WorkLogs: "WORK_LOGS",
        WorkLogsDailyWage: "WL_DAILY_WAGE",
        WorkLogsTimeTracking: "WORK_LOGS_TIME_TRACKING",
        WorkLogsStrictShifts: "WL_STRICT_SHIFTS",
        WorkLogsShiftPlanning: "WL_SHIFT_PLANNING",
        WorkLogsShiftRosterPlanning: "WL_SHIFT_ROSTER_PLANNING",
        CustomWeeklySchedules: "WEEKLY_CUSTOM_WORK_SCHEDULES",
        Payroll: "PAYROLL",
        PayrollPartial: "PAYROLL_PARTIAL",
        LeaveManagement: "LEAVE_MANAGEMENT",
        EmployeeSystemAccess: "EMPLOYEE_SYSTEM_ACCESS",
        MultiBranch: "MULTI_BRANCH",
        Teams: "TEAMS",
        AttendanceQR: "ATTENDANCE_QR",
    },
    StockMarket: {
        EventAnalytics: "STOCK_MARKET_EVENT_ANALYTICS",
    },
    Misc: {
        Projects: "PROJECTS",
        ProjectTimeLogs: "PROJECT_TIME_LOGS",
    },
};

export const ConfigKeys = {
    WorkLog: {
        WeeklyWorkingDays: "WORKLOG_WEEKLY_WORKING_DAYS",
        AttendanceStrategy: "WORKLOG_ATTENDANCE_STRATEGY",
        OTApprovalRequired: "WORKLOG_OT_APPROVAL_REQUIRED",
        ShortLeaveMins: "WORKLOG_SHORT_LEAVE_MINS",
    },
    Leave: {
        MinMonthsForDefaultLeaveEntitlement: "HR_MIN_MONTHS_TO_SERVE_FOR_DEFAULT_LEAVE_ELIGIBILITY",
    },
};

export const DefaultPageSizes = {
    sm: 10,
    md: 25,
    CropStats: 50,
    Trees: 50,
    HarvestLogs: 25,
    WorkLogs: 50,
    Transactions: 50,
    Employees: 25,
    AttendanceLogs: 50,
    EmployeeLeave: 25,
    LeaveRequests: 25,
};

export const REGEX_PHONE_NUMBER = /^(?:(?:\+?\d{1,3}[ -]?)?(?:\(?\d{1,3}\)?[ -]?)?\d{3}[ -]?\d{3}[ -]?\d{4}|\d{10})$/;

export const LookupTypes = {
    IncomeTypes: "INCOME_TYPES",
    ExpenseTypes: "EXPENSE_TYPES",
    CropFallenReasons: "CROP_FALLEN_REASONS",
    Designations: "DESIGNATIONS",
    AddHocAllowanceTypes: "AD_HOC_ALLOWANCE_TYPES",
    AddHocDeductionTypes: "AD_HOC_DEDUCTION_TYPES",
};

export const LookupTitles = {
    [LookupTypes.IncomeTypes]: "Income Types",
    [LookupTypes.ExpenseTypes]: "Expense Types",
    [LookupTypes.CropFallenReasons]: "Crop Fallen Reasons",
    [LookupTypes.Designations]: "Designations",
    [LookupTypes.AddHocAllowanceTypes]: "Ad-hoc Allowance Type",
    [LookupTypes.AddHocDeductionTypes]: "Ad-hoc Deduction Type",
};
